import { useMemo } from 'react';

const EMOJIS = ['🏆', '⭐', '💰', '🎰', '✨', '🎯', '🎲', '💎'];

interface FallingEmoji {
  id: number;
  emoji: string;
  x: number;
  size: number;
  duration: number;
  delay: number;
  opacity: number;
  rotation: number;
}

/**
 * PinsBackground — page backdrop for player surfaces: the page color, a pool
 * of the brand color at the top (the "spotlight" the logo tile sits in), and a
 * slow, barely-there drizzle of prize emojis.
 */
const PinsBackground = () => {
  const emojis = useMemo<FallingEmoji[]>(() => {
    return Array.from({ length: 12 }, (_, i) => ({
      id: i,
      emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
      x: Math.random() * 100,
      size: 16 + Math.random() * 24,
      duration: 15 + Math.random() * 20,
      delay: Math.random() * 15,
      opacity: 0.04 + Math.random() * 0.06,
      rotation: Math.random() * 360,
    }));
  }, []);

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none" style={{ contain: 'strict' }} aria-hidden="true">
      {/* Page color */}
      <div className="absolute inset-0 bg-background" />

      {/* Brand spotlight at the top of the page */}
      <div className="brand-spotlight absolute inset-x-0 top-0 h-[60vh]" />

      {/* A faint echo of the brand color at the bottom keeps the page from feeling cut off */}
      <div
        className="absolute inset-x-0 bottom-0 h-[40vh]"
        style={{
          background: 'radial-gradient(70% 60% at 50% 110%, hsl(var(--primary) / 0.10) 0%, transparent 70%)',
        }}
      />

      {/* Falling emojis - pure CSS animations */}
      {emojis.map((item) => (
        <div
          key={item.id}
          className="absolute select-none emoji-fall"
          style={{
            left: `${item.x}%`,
            fontSize: `${item.size}px`,
            opacity: item.opacity,
            animationDuration: `${item.duration}s`,
            animationDelay: `${item.delay}s`,
            '--start-rotation': `${item.rotation}deg`,
            '--end-rotation': `${item.rotation + 360}deg`,
            willChange: 'transform',
          } as React.CSSProperties}
        >
          {item.emoji}
        </div>
      ))}
    </div>
  );
};

export default PinsBackground;
